export interface ToastConfig {
    text: string;
    key: string;
    duration?: number;
}

export interface ToastEngine {
    info(config: ToastConfig): void;

    success(config: ToastConfig): void;

    warn(config: ToastConfig): void;

    error(config: ToastConfig): void;
}

class Toast {

    private static engine: ToastEngine;

    public static setEngine(engine: ToastEngine) {
        this.engine = engine;
    }

    public static info(config: ToastConfig): void {
        this.engine.info(config);
    }

    public static success(config: ToastConfig): void {
        this.engine.success(config);
    }

    public static warn(config: ToastConfig): void {
        this.engine.warn(config);
    }

    public static error(config: ToastConfig): void {
        this.engine.error(config);
    }
}

export default Toast;
